import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function Signup() {
    const { signup } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({
        organization_name: "", name: "", email: "", password: "",
    });
    const [loading, setLoading] = useState(false);
    const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await signup(form);
            toast.success("Workspace created");
            nav("/", { replace: true });
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Signup failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2 bg-white">
            <div className="hidden lg:flex flex-col justify-between p-12 border-r border-border grid-bg">
                <div>
                    <img src="/scout-ai-logo.png" alt="Scout AI" className="h-12 w-auto" />
                </div>
                <div className="max-w-md">
                    <p className="font-heading text-3xl font-bold leading-tight">
                        Your AI-powered command center for B2B growth.
                    </p>
                    <p className="text-muted-foreground mt-3">
                        Discover leads, research with AI, manage your pipeline — in one operating system.
                    </p>
                </div>
            </div>

            <div className="flex items-center justify-center p-8">
                <form onSubmit={submit} className="w-full max-w-sm space-y-5">
                    <div>
                        <div className="overline text-muted-foreground">Get started</div>
                        <h1 className="font-heading text-4xl font-black mt-2">Create your workspace.</h1>
                    </div>
                    <div className="space-y-3">
                        <div>
                            <label className="overline text-muted-foreground">Organization name</label>
                            <input data-testid="signup-org" required value={form.organization_name}
                                onChange={set("organization_name")} className="input-os mt-1" placeholder="Kaleido Studios" />
                        </div>
                        <div>
                            <label className="overline text-muted-foreground">Your name</label>
                            <input data-testid="signup-name" required value={form.name}
                                onChange={set("name")} className="input-os mt-1" placeholder="Alex Doe" />
                        </div>
                        <div>
                            <label className="overline text-muted-foreground">Email</label>
                            <input data-testid="signup-email" type="email" required value={form.email}
                                onChange={set("email")} className="input-os mt-1" placeholder="you@company.com" />
                        </div>
                        <div>
                            <label className="overline text-muted-foreground">Password</label>
                            <input data-testid="signup-password" type="password" required minLength={6} value={form.password}
                                onChange={set("password")} className="input-os mt-1" placeholder="At least 6 characters" />
                        </div>
                    </div>
                    <button data-testid="signup-submit" type="submit" disabled={loading}
                        className="btn-primary w-full disabled:opacity-50">
                        {loading ? "Creating…" : "Create workspace"}
                    </button>
                    <div className="text-sm text-muted-foreground text-center">
                        Already have an account?{" "}
                        <Link data-testid="goto-login" to="/login" className="text-brand font-medium hover:underline">
                            Sign in
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
